import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import {ActivityDetails} from './activityDetails';
import { FrenchTypes } from '../../../../../../../constants/utils/connectionTypes';

export const Activity = ({userId, serviceDatas, disableModifications, generateLetters}) => {
    const [activityState, setActivityState] = useState({
        items: []
    });

    useEffect(() => {
        let activitiesInState = serviceDatas.filter(s => s.serviceType === FrenchTypes.activity);
        if (activitiesInState.length > 0){
            setActivityState({
                items: activitiesInState
            });
        }else{
            setActivityState({...activityState, items: activityState.items.concat({})});
        }
    }, [serviceDatas]);

    function removeActivity(activity) {
        setActivityState({...activityState, items: activityState.items.filter(a => a !== activity)});
    }

    return (
        <article className="block" id="activité">
            <h3 className="sr-only visually-hidden">En activité</h3>
            {
                activityState.items.map((activity, index) => {
                    return <ActivityDetails key={index} index={index} userId={userId} activity={activity} removeActivity={removeActivity} disableModifications={disableModifications} generateLetters={generateLetters} />
                })
                    
            }
            
            <footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
                <h4 className="sr-only visually-hidden">Ajouter une autre ACTIVITÉ</h4>
                <button type="button" className="btn btn-icon btn-alert-info mx-auto py-2" onClick={(e) => {
                    const nodes = window.document.querySelectorAll('.collapse.show');
                    if (!R.isNil(nodes) && nodes.length > 0) {
                        nodes.forEach(element => {
                            element.classList.remove(['show']);
                        });
                    }
                    setActivityState({...activityState, items: activityState.items.concat({
                        type: 'Activite',
                        companyName: "",
                        companyAddressStreet1: "",
                        companyAddressStreet2: "",
                        companyAddressPostalCode: "",
                        companyAddressLocality: "",
                        companyAddressCountry: "FR",
                        function: "",
                        contractType: "CDD",
                        companySavingsPlanReference: ""
                    })});
                }}>
                    <i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre ACTIVITÉ
				</button>
            </footer>
        </article>
    )
}